/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import {
  Button, Grid, Dialog, DialogTitle, DialogActions, DialogContent, TextField,
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import Select from 'react-select';
import Loading from '../../../components/loading/Loading';
import FlashContext from '../../../components/contexts/FlashContext';
import api from '../../../service/axios/api';

const selectStyles = {
  control: provided => ({ ...provided, height: 56, minHeight: 56 }),
  menu: provided => ({ ...provided, zIndex: 9999 }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
};

const typeOptions = [
  { value: 'Fixa', label: 'Fixa' },
  { value: 'Variável', label: 'Variável' },
];

const recurrenceOptions = [
  { value: 'Semanal', label: 'Semanal' },
  { value: 'Quinzenal', label: 'Quinzenal' },
  { value: 'Mensal', label: 'Mensal' },
  { value: 'Semestral', label: 'Semestral' },
  { value: 'Anual', label: 'Anual' },
];

export default function EditBill({
  openEdit, setOpenEdit, loadingEdit, handleEdit,
  obs, setObs,
  predictedValue, setPredictedValue,
  dueDate, setDueDate,
  category, setCategory,
  payingMethod, setPayingMethod,
  supplier, setSupplier,
  center, setCenter,
  type, setType,
  nfeNumber, setNfeNumber,
  dateIssue, setDateIssue,
  bankId, setBankId,
  recurrenceType, setRecurrenceType,
  originalRecurrenceType,
  installmentsCount, setInstallmentsCount,
  installmentNumber,
  installmentTotal,
}) {
  const { notifyError } = useContext(FlashContext);
  const [bankList, setBankList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [centerList, setCenterList] = useState([]);
  const [categoryList, setCategoryList] = useState([]); 

  const getBanks = async () => {
    try {
      const data = await api.banks.get(false, 'Active');
      setBankList(data.retorno.map(i => ({ value: i.id, label: i.bank })));
    } catch (error) { notifyError(error.message); }
  };

  const getSuppliers = async () => {
    try {
      const { data } = await api.supplier.getAllSelect();
      setSupplierList(data.retorno.map(i => ({ value: i.id, label: i.supplier_name })));
    } catch (error) { notifyError(error.message); }
  };

  const getCenters = async () => {
    try {
      const { data } = await api.costCenter.getAllSelect();
      setCenterList(data.retorno.map(i => ({ value: i.id, label: i.name })));
    } catch (error) { notifyError(error.message); }
  };


  const getCategories = async () => {
    try {
      const { data } = await api.category.getAll([], 999, 1);
      setCategoryList(data.docs.map(i => ({ value: i.id, label: i.name })));
    } catch (error) { notifyError(error.message); }
  };

  useEffect(() => {
    if (openEdit) {
      getBanks();
      getSuppliers();
      getCenters();
      getCategories(); 
    }
  }, [openEdit]);

  return (
    <Dialog onClose={() => setOpenEdit(false)} open={openEdit} fullWidth maxWidth="sm">
      <Loading open={loadingEdit} msg="Salvando..." />
      <DialogTitle>Editar Conta</DialogTitle>
      {installmentTotal > 1 && (
        <div style={{ padding: '0 24px', color: '#657588', fontSize: 13 }}>
          Parcela {installmentNumber} de {installmentTotal} — faz parte de
          uma série recorrente.
          {recurrenceType !== originalRecurrenceType && (
            <strong style={{ color: '#c0392b', display: 'block', marginTop: 4 }}>
              Atenção: ao salvar com o tipo de recorrência alterado, as
              demais parcelas PENDENTES desta série serão canceladas e uma
              nova série será gerada com a quantidade informada abaixo,
              a partir do vencimento da 1ª parcela original. Parcelas já
              pagas não serão afetadas.
            </strong>
          )}
        </div>
      )}
      <DialogContent>
        <Grid container spacing={3} style={{ justifyContent: 'center' }}>

          {installmentTotal > 1 && (
            <Grid item sm={6} xs={12}>
              <Select
                value={
                  recurrenceOptions.find(opt => opt.value === recurrenceType) || null
                }
                placeholder="Tipo de recorrência"
                onChange={e => setRecurrenceType(e ? e.value : '')}
                options={recurrenceOptions}
                styles={selectStyles}
                isClearable
                menuPortalTarget={document.body}
              />
            </Grid>
          )}

          {installmentTotal > 1 && recurrenceType !== originalRecurrenceType && (
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                type="number"
                label="Novo número de repetições"
                variant="outlined"
                value={installmentsCount}
                onChange={e => setInstallmentsCount(e.target.value)}
                inputProps={{ min: 2, max: 360 }}
                helperText="Quantas parcelas a série corrigida deve ter"
              />
            </Grid>
          )}

          {/* Tipo */}
          <Grid item sm={6} xs={12}>
            <Select
              value={typeOptions.find(opt => opt.value === type) || null}
              placeholder="Tipo (Fixa / Variável)"
              onChange={e => setType(e ? e.value : '')}
              options={typeOptions}
              styles={selectStyles}
            />
          </Grid>

          {/* Fornecedor */}
          <Grid item sm={6} xs={12}>
            <Select
              value={supplierList.find(opt => opt.value === supplier) || null}
              placeholder="Fornecedor"
              onChange={e => setSupplier(e ? e.value : null)}
              options={supplierList}
              styles={selectStyles}
              isClearable
            />
          </Grid>

          {/* Centro de Custo */}
          <Grid item sm={6} xs={12}>
            <Select
              value={centerList.find(opt => opt.value === center) || null}
              placeholder="Centro de Custo"
              onChange={e => setCenter(e ? e.value : null)}
              options={centerList}
              styles={selectStyles}
              isClearable
            />
          </Grid>

          {/* Conta Bancária */}
          <Grid item sm={6} xs={12}>
            <Select
              value={bankList.find(opt => opt.value === bankId) || null}
              placeholder="Conta Bancária"
              onChange={e => setBankId(e ? e.value : null)}
              options={bankList}
              styles={selectStyles}
              isClearable
            />
          </Grid>

          {/* Valor Previsto */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label="Valor Previsto"
              variant="outlined"
              value={predictedValue}
              onChange={e => setPredictedValue(e.target.value)}
              placeholder="0,00"
            />
          </Grid>

          {/* Vencimento */}
          <Grid item sm={6} xs={12}>
            <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                label="Vencimento"
                variant="inline"
                inputVariant="outlined"
                style={{ backgroundColor: '#fff' }}
                size="medium"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={dueDate}
                onChange={date => setDueDate(date)}
              />
            </MuiPickersUtilsProvider>
          </Grid>

      
          <Grid item sm={6} xs={12}>
            <Select
              value={categoryList.find(opt => opt.value === category) || null}
              placeholder="Categoria"
              onChange={e => setCategory(e ? e.value : null)}
              options={categoryList}
              styles={selectStyles}
              isClearable
              menuPortalTarget={document.body}
            />
          </Grid>

          {/* Forma de Pagamento */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label="Forma de Pagamento"
              variant="outlined"
              value={payingMethod}
              onChange={e => setPayingMethod(e.target.value)}
            />
          </Grid>

          {/* Número NFe */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label="Número NFe"
              variant="outlined"
              value={nfeNumber}
              onChange={e => setNfeNumber(e.target.value)}
            />
          </Grid>

          {/* Data de Emissão */}
          <Grid item sm={6} xs={12}>
            <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                label="Data de Emissão"
                variant="inline"
                inputVariant="outlined"
                style={{ backgroundColor: '#fff' }}
                size="medium"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={dateIssue}
                onChange={date => setDateIssue(date)}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          {/* Descrição */}
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              label="Descrição"
              variant="outlined"
              value={obs}
              onChange={e => setObs(e.target.value)}
              multiline
              rows={2}
              maxRows={10}
            />
          </Grid>

        </Grid>
      </DialogContent>
      <DialogActions>
        <Button style={{ height: 40 }} onClick={() => setOpenEdit(false)} variant="text" color="primary">
          Cancelar
        </Button>
        <Button style={{ height: 40 }} onClick={handleEdit} disabled={loadingEdit} variant="contained" color="primary">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}